import {
  OTP_SENT_TO_EMAIL,
  OTP_SENT_TO_MESSAGE,
  OTP_SENT_TO_REG_MESSAGE,
} from 'constants/messages.constant';
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  CloseButton,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
  Spinner,
} from 'react-bootstrap';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import RadioCard from './components/radioCard';
import format from 'string-template';
import signupService from './services/signup.service';
import logo from 'assets/images/eb-logo.svg';
import Toast from 'shared/common/toast';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { Field, Form as FormikForm, Formik } from 'formik';
import * as Yup from 'yup';
import infoIco from 'assets/images/i-circle.svg';
import Verified from 'assets/images/verified.gif';
import hidden from '../../assets/images/hidden.png';
import eye from '../../assets/images/eye.png';
import { toBase64 } from 'utils';
import LoginService from 'pages/login/services/login.service';
import Loader from 'shared/common/loader';

type Props = {};
const SUPPORTED_FORMATS = [
  // 'image/jpg',
  // 'image/jpeg',
  // 'image/png',
  'application/pdf',
  // 'application/msword',
];
const FILE_SIZE = 5 * 1024 * 1024;

const EnterpriseSignup = (props: Props) => {
  const initialValues = {
    pan_number: '',
    is_gstin_available: '',
    gstin_number: '',
    company_type: '',
    company_name: '',
    address_line: '',
    state: '',
    city: '',
    pincode: '',
    mobile: '',
    email: '',
    contact_person: '',
    // brFile: '',
    password: '',
    confirm_password: '',
    agree: false,
    referralCode: '',
  };
  const validationSchema = Yup.object().shape({
    pan_number: Yup.string()
      .matches(/^[A-Z0-9]+$/, 'Special characters are not allowed')
      .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, 'PAN is invalid')
      .trim('PAN is invalid')
      .required('PAN is required'),
    is_gstin_available: Yup.string().required(
      'Please select GSTIN availibility'
    ),
    gstin_number: Yup.string().when('is_gstin_available', {
      is: (val) => (val && val === 'GSTIN_YES' ? true : false),
      then: Yup.string()
        .matches(/^[A-Z0-9]+$/, 'Special characters are not allowed')
        .trim('GSTIN is invalid')
        .required('GSTIN is required'),
    }),
    company_type: Yup.string().required('Company type is required'),
    company_name: Yup.string().required('Company name is required'),
    address_line: Yup.string().required('Address is required'),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    pincode: Yup.string()
      .matches(/^[0-9]{6,6}$/, 'Invalid pincode')
      .required('Pincode is required'),
    mobile: Yup.string()
      .matches(/^[0-9]+$/, 'Please enter a valid mobile number')
      .test(
        'len',
        'Please enter a valid mobile number',
        (val) => val?.length === 10
      )
      .required('Invalid mobile number'),
    email: Yup.string().email('Invalid email').required('Email is required'),
    contact_person: Yup.string()
      .matches(/^[a-zA-Z ]+$/, 'Special characters are not allowed')
      .trim('Name is invalid')
      .required('Name is required'),
    // brFile: Yup.mixed()
    //   .nullable()
    //   .required('Document is required')
    //   .test('fileSize', 'File is bigger than 1MB', (value) => {
    //     console.log('file size ', value);
    //     return value && value?.size <= FILE_SIZE;
    //   })
    //   .test(
    //     'fileType',
    //     'Unsupported file format. Please upload file in PDF format',
    //     (value) => value && SUPPORTED_FORMATS.includes(value?.type)
    //   ),
    password: Yup.string()
      .required('Password is required')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        'The password must be at least 8 characters and it must contain at least one uppercase, one lowercase, one number and one special character.'
      ),

    confirm_password: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Passwords do not match')
      .required('Confirm Password is required'),
    agree: Yup.boolean()
      .required('The terms and conditions must be accepted.')
      .oneOf([true], 'The terms and conditions must be accepted.')
      .default(false),
  });
  const companyNameRef = useRef();
  const companyTypeRef = useRef();
  const addressLineRef = useRef();
  const cityRef = useRef();
  const stateRef = useRef();
  const pincodeRef = useRef();
  const [isOtpModalDisplayed, setIsOtpModalDisplayed] = useState(false);
  const [pan, setPan] = useState('');
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [isPanLoading, setIsPanLoading] = useState(false);
  const [isPanChanged, setIsPanChanged] = useState(true);
  const [isGstnLoading, setIsGstnLoading] = useState(false);
  const [isGstVerified, setIsGstVerified] = useState(false);
  const [errorModal, setErrorModal] = useState<any>({});
  const [isGstinDisclaimer, setIsGstinDisclaimer] = useState(false);
  const [isDisclaimerDisplayed, setIsDisclaimerDisplayed] = useState(false);
  const [gstns, setGstns] = useState([]);
  const [gstnMeta, setGstnMeta] = useState(null);
  const [companyDetails, setCompanyDetails] = useState({
    company_type: '',
    company_name: '',
    address_line: '',
    state: '',
    city: '',
    pincode: '',
  });
  const [selectedGstin, setSelectedGstin] = useState('');
  const [contact, setContact] = useState({ mobile: '', email: '', spoc: '' });
  const [otpData, setOtpData] = useState<OtpData>({
    type: '',
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });
  const [isShowPwd, setShowPwd] = useState(false);
  const [isShowCnfPwd, setShowCnfPwd] = useState(false);

  const [referralCode, setReferralCode] = React.useState('');
  const [InvalidRC, setInvalidRC] = React.useState('');
  const [isInvalidRC, setIsInvalidRC] = React.useState(false);
  const [busPartName, setBusPartName] = React.useState('');

  let history = useHistory();

  const resetOtpData = () => {
    setOtpData({
      type: '',
      value: '',
      ackMessage: '',
      ackMessageType: 'success',
    });
  };

  const resetContact = (setFieldValue) => {
    setContact({ mobile: '', email: '', spoc: '' });
    setFieldValue('contact_person', '');
    setFieldValue('email', '');
    setFieldValue('mobile', '');
    setFieldValue('password', '');
    setFieldValue('confirm_password', '');
  };

  const resetCompanyDetails = () => {
    setCompanyDetails({
      company_type: '',
      company_name: '',
      address_line: '',
      state: '',
      city: '',
      pincode: '',
    });
  };

  const onSubmitOTP = () => {
    // if (otpData.type === 'mobile') {
    verifyOtp(otpData.value);
    setIsOtpModalDisplayed(false);
    // }
    // else {
    //   verifyOtp(otpData.value);
    // }
  };

  const verifyOtp = async (otp) => {
    try {
      setOtpLoading(true);
      const res: any = await signupService.verifyOTP(pan, otp);
      setOtpLoading(false);

      if (res == 'SUCCESS') {
        toast.success(
          'User registration successful. You will now be redirected to login page.'
        );
        setPageLoading(true);
        setTimeout(() => {
          history.push('/signin');
        }, 2000);
      }
    } catch (err) {
      setOtpLoading(false);
      toast.error('Mobile verification failed!');
    }
  };

  const verifyPan = (pan, setFieldError) => {
    if (pan?.length === 10 && /[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(pan)) {
      // TODO: Call pan verification api here
      resetCompanyDetails();
      setIsPanVerified(true);
    } else {
      setFieldError('pan_number', 'Invalid PAN');
    }
  };

  const resendMobileOTP = async () => {
    setLoading(true);
    try {
      const res: any = await LoginService.entSendOTP(pan);
      setLoading(false);
      if (res) {
        toast.success('OTP sent successfully');
      }
    } catch (err: any) {
      setLoading(false);
      toast.error(err.message, {
        className: 'toast-position-signup',
      });
    }
  };

  const getGstns = async (pan, setFieldError) => {
    if (pan?.length === 10 && /[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(pan)) {
      try {
        setIsPanLoading(true);
        const res: any = await signupService.getGstns({ pan });

        if (res.status === 200 && res.data.data) {
          if (res.data.data.gstins?.length > 0) {
            setIsPanVerified(true);
            setIsGstVerified(false);
            setGstns(res.data.data.gstins);
            setFieldError('pan_number', '');
          } else {
            setFieldError(
              'pan_number',
              'No GSTIN Number is linked to provided PAN'
            );
          }
        }
      } catch (e: any) {
        console.log(e.message);
        setFieldError('pan_number', 'Error while fetching PAN details');
      } finally {
        setIsPanLoading(false);
      }
    } else {
      setFieldError('pan_number', 'Invalid PAN');
    }
  };

  const getGstinDetails = async (gstin, setFieldValue, setFieldError) => {
    setIsGstnLoading(true);
    try {
      const res: any = await signupService.getGstinDetails({ gstin });
      if (res.status === 200 && res.data.data) {
        setIsGstVerified(true);
        setCompanyDetails({
          ...companyDetails,
          company_name: res.data.data.gst_metadata.name,
          address_line: res.data.data.address.address1,
          state: res.data.data.address.state,
          city: res.data.data.address.city,
          pincode: res.data.data.address.pinCode,
        });
        setFieldValue('company_name', res.data.data.gst_metadata.name);
        setFieldValue('address_line', res.data.data.address.address1);
        setFieldValue('state', res.data.data.address.state);
        setFieldValue('city', res.data.data.address.city);
        setFieldValue('pincode', res.data.data.address.pinCode);
        setGstnMeta(JSON.stringify(res.data.data.gst_metadata));
      }
    } catch (e: any) {
      console.log(e.message);
      setFieldValue('company_name', '');
      setFieldValue('address_line', '');
      setFieldValue('state', '');
      setFieldValue('city', '');
      setFieldValue('pincode', '');
      setGstnMeta(null);
    } finally {
      setIsGstnLoading(false);
    }
  };

  const signUp = async (values, setFieldError) => {
    if (
      values?.pan_number?.length === 10 &&
      /[A-Z]{5}[0-9]{4}[A-Z]{1}/.test(values?.pan_number)
    ) {
      setLoading(true);

      let nonGstCompanyDetails = {
        name: values.company_name,
        tradename: values.company_name,

        pradr: {
          bnm: '',
          st: '',
          loc: values.city,
          bno: values.address_line,
          stcd: values.state,
          flno: '',
          lt: '',
          lg: '',
          pncd: values.pincode,
          ntr: '',
          district: values.city,
          city: values.city,
        },
      };

      let payload = {
        pan: values.pan_number,
        password: values.password,
        userType: 'B2B_CUSTOMER',
        mobile: {
          value: `+91${values.mobile}`,
          isVerified: false,
        },
        email: {
          value: values.email,
          isVerified: false,
        },
        firstName: values.contact_person,
        lastName: values.contact_person,
        displayName: values.contact_person,
        poolId: process.env.REACT_APP_B2B_POOL_ID,
        active: 'ENABLED',
        customerType: values.company_type,
        gst_metadata:
          values.is_gstin_available === 'GSTIN_YES'
            ? gstnMeta
            : JSON.stringify(nonGstCompanyDetails),
        referralCode: referralCode,
        consent: values.agree,
      };
      try {
        if (isInvalidRC) {
          setLoading(false);
          return toast.error(InvalidRC);
        } else {
          const res: any = await signupService.enterpriseSignUp(payload);

          if (res.status === 200 && res.data.data) {
            setLoading(false);
            setOtpData({ ...otpData, type: 'mobile' });
            setIsGstVerified(true);
            setIsOtpModalDisplayed(true);
          }
        }
      } catch (e: any) {
        if (e?.data?.errors[0]?.title) {
          toast.error(e?.data?.errors[0]?.title);
        }
        console.log(e);
        setLoading(false);
      }
    } else {
      setFieldError('pan_number', 'Invalid PAN');
    }
  };

  const resetComapanyForm = (setErrors, setFieldValue, setTouched) => {
    setErrors({
      company_name: '',
      address_line: '',
      state: '',
      city: '',
      pincode: '',
    });
    setFieldValue('company_name', '');
    setFieldValue('address_line', '');
    setFieldValue('state', '');
    setFieldValue('city', '');
    setFieldValue('pincode', '');
    setTouched(
      {
        company_name: false,
        address_line: false,
        state: false,
        city: false,
        pincode: false,
      },
      true
    );
  };

  const isValidReferral = async (
    code: any,
    setFieldError: (field: string, message: string) => void
  ) => {
    try {
      const res: any = await LoginService.isValidReferralCode(code);
      setReferralCode(code);
      setBusPartName(res?.data?.data[0]?.businessName);
      setFieldError('referralCode', ''); // Replace 'fieldName' with the name of the field you want to set an error for
      setInvalidRC('');
      setIsInvalidRC(false);
    } catch (err) {
      console.log(err);
      setIsInvalidRC(true);
      // Assuming err contains the error message
      // toast.error('Invalid Referral Code');
      // toast.error('Invalid Referral Code', {
      //   className: 'toast-position-signup',
      // });
      setInvalidRC('Invalid Referral Code');
      setBusPartName('');
      setFieldError('referralCode', 'Invalid Referral Code'); // Replace 'fieldName' with the name of the field you want to set an error for
    }
  };

  useEffect(() => {
    const refB2Bcode = localStorage.getItem('refCode');
    if(refB2Bcode){
      isValidReferral(refB2Bcode, () => {});
      setReferralCode(refB2Bcode);
    }
  }, []);

  return (
    <div>
      <Toast />
      {pageLoading && <Loader />}
      <div className='login-wrapper'>
        <div className='login-banner d-none d-sm-block d-sm-flex'>
          <img src={logo} alt='' />
        </div>
        <div className='login-form'>
          <div className='ent-form-group'>
            <div className='mt-0 my-5 d-sm-block d-md-none'>
              <img src={logo} alt='' />
            </div>
            <div className='title'>
              <h3>Create your enterprise account</h3>
              <p>Setup your account and start your bullion journey today</p>
            </div>
            <div>
              <OtpPopup
                show={isOtpModalDisplayed}
                isLoading={otpLoading}
                handleClose={() => {
                  resetOtpData();
                  setIsOtpModalDisplayed(false);
                }}
                modalTitle={'Verify Mobile Number'}
                modalSubmitBtnText='Verify'
                onSubmit={() => onSubmitOTP()}
                otpLabel={format(OTP_SENT_TO_MESSAGE, {
                  suffixDigits: contact?.mobile?.slice(-4),
                })}
                enableResendTimer={true}
                resendHandler={() => {
                  resetOtpData();
                  resendMobileOTP();
                }}
                otpChangeHandler={(value) => {
                  setOtpData({
                    ...otpData,
                    value: value,
                    ackMessage: '',
                    ackMessageType: 'success',
                  });
                }}
                resendButtonText='Resend OTP'
                ackMessage={otpData.ackMessage}
                ackMessageType={otpData.ackMessageType}
                numInputs={6}
                otpValue={otpData.value}
                resendInterval={30}
              />
              <Modal
                show={isGstinDisclaimer && isDisclaimerDisplayed === false}
                onHide={() => {
                  setIsGstinDisclaimer(false);
                  setIsDisclaimerDisplayed(true);
                }}
                // backdrop='static'
                keyboard={false}
                aria-labelledby='contained-modal-title-vcenter'
                centered
              >
                <Modal.Header>
                  <div className='d-flex w-100 justify-content-between align-items-center'>
                    {errorModal?.title && (
                      <h4 className='text-center my-1'>{errorModal?.title}</h4>
                    )}
                    <CloseButton
                      onClick={() => {
                        setIsGstinDisclaimer(false);
                        setIsDisclaimerDisplayed(true);
                      }}
                    ></CloseButton>
                  </div>
                </Modal.Header>
                <Modal.Body>
                  {errorModal?.message && (
                    <small>
                      <p className='h6 m-2 ' style={{ textAlign: 'justify' }}>
                        {errorModal?.message}
                      </p>
                    </small>
                  )}
                  <div className='text-center'>
                    <Button
                      className='w-50 mt-3'
                      variant='primary'
                      onClick={() => {
                        setIsGstinDisclaimer(false);
                        setIsDisclaimerDisplayed(true);
                      }}
                    >
                      I agree
                    </Button>
                  </div>
                </Modal.Body>
              </Modal>
              <Formik
                // innerRef={ref}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, { setFieldError, setFieldTouched }) => {
                  signUp(values, setFieldError);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  setFieldError,
                  setFieldValue,
                  setFieldTouched,
                  setErrors,
                  setTouched,
                  validateField,
                }) => (
                  <FormikForm>
                    <Form.Group
                      className='mb-3 '
                      controlId='entForm.ControlInput1'
                    >
                      {/* <pre>{JSON.stringify(values)}</pre>
                      <pre>{JSON.stringify(errors)}</pre>
                      <pre>{JSON.stringify(touched)}</pre> */}
                      <Row>
                        <Col md={4}>
                          <Form.Label>
                            Permanent Account Number (PAN)
                          </Form.Label>
                          {/* <small className='small text-muted'>
                            (Permanent Account Number)
                          </small> */}
                        </Col>
                        <Col md={8}>
                          <InputGroup className='mb-1'>
                            <Field
                              type='text'
                              className='form-control'
                              placeholder=''
                              name='pan_number'
                              disabled={isPanVerified}
                              onBlur={(e) => {
                                setFieldTouched('pan_number');
                              }}
                              value={pan}
                              onChange={(e) => {
                                if (e.target.value.length > 10) return;
                                setFieldValue(
                                  'pan_number',
                                  e.target.value?.toUpperCase()
                                );
                                setPan(e.target.value?.toUpperCase());
                                setIsPanChanged(true);
                              }}
                            />
                            {isPanLoading ? (
                              <div className='input-group-text px-2'>
                                <Spinner animation='border' size='sm' />
                              </div>
                            ) : (
                              !errors.pan_number &&
                              !isPanChanged && (
                                <div className='input-group-text px-2'>
                                  <img
                                    src={Verified}
                                    width='22px'
                                    height='22px'
                                  />
                                </div>
                              )
                            )}
                            {isPanChanged && !isPanLoading && isPanVerified && (
                              <button
                                className='btn btn-verify'
                                id='button-pan'
                                type='button'
                                onClick={() => {
                                  resetCompanyDetails();
                                  resetComapanyForm(
                                    setErrors,
                                    setFieldValue,
                                    setTouched
                                  );
                                  resetContact(setFieldValue);
                                  setSelectedGstin('');
                                  setIsGstVerified(false);
                                  setIsPanVerified(false);
                                  setFieldValue('is_gstin_available', '');
                                }}
                              >
                                Edit
                              </button>
                            )}
                          </InputGroup>
                          <div className='error'>
                            {errors.pan_number && touched.pan_number && (
                              <small id='my-helper-text'>
                                <img src={infoIco} alt='' />
                                {errors.pan_number}
                              </small>
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4}>
                          <Form.Label>
                            Do you have GSTIN linked with entered PAN?
                          </Form.Label>
                        </Col>
                        <Col md={8}>
                          <Row>
                            <Col md={6}>
                              <RadioCard
                                label={'Yes'}
                                id={'GSTIN_YES'}
                                name='IS_GSTIN'
                                onChange={(e) => {
                                  setSelectedGstin(e.target.id);
                                  setFieldValue(
                                    'is_gstin_available',
                                    'GSTIN_YES'
                                  );

                                  setGstnMeta(null);
                                  resetContact(setFieldValue);
                                  resetComapanyForm(
                                    setErrors,
                                    setFieldValue,
                                    setTouched
                                  );
                                  setIsPanVerified(false);
                                }}
                                checked={
                                  values.is_gstin_available === 'GSTIN_YES'
                                }
                                // disabled={isPanVerified}
                              />
                            </Col>
                            <Col md={6}>
                              <RadioCard
                                label={'No'}
                                id={'GSTIN_NO'}
                                name='IS_GSTIN'
                                onChange={(e) => {
                                  setFieldValue(
                                    'is_gstin_available',
                                    'GSTIN_NO'
                                  );
                                  resetContact(setFieldValue);
                                  resetComapanyForm(
                                    setErrors,
                                    setFieldValue,
                                    setTouched
                                  );

                                  setGstnMeta(null);
                                  setIsPanVerified(false);
                                }}
                                checked={
                                  values.is_gstin_available === 'GSTIN_NO'
                                }
                                // disabled={isPanVerified}
                              />
                            </Col>
                          </Row>
                          <div className='error'>
                            {errors.is_gstin_available &&
                              touched.is_gstin_available && (
                                <small id='my-helper-text'>
                                  <img src={infoIco} alt='' />
                                  {errors.is_gstin_available}
                                </small>
                              )}
                          </div>
                        </Col>
                      </Row>
                      {isPanVerified ? null : (
                        <Button
                          className='w-100 mt-3'
                          variant='primary'
                          type='button'
                          disabled={isPanLoading}
                          onClick={() => {
                            setFieldTouched('pan_number', true);
                            setFieldTouched('is_gstin_available', true);
                            validateField('pan_number');
                            validateField('is_gstin_available');
                            if (
                              !errors.pan_number &&
                              values.is_gstin_available
                            ) {
                              if (values.is_gstin_available === 'GSTIN_YES') {
                                setGstnMeta(null);
                                getGstns(
                                  values.pan_number?.toUpperCase(),
                                  setFieldError
                                );
                              } else {
                                setGstnMeta(null);
                                verifyPan(
                                  values.pan_number?.toUpperCase(),
                                  setFieldError
                                );
                              }
                            }
                          }}
                        >
                          Continue
                          {isPanLoading ? (
                            <Spinner animation='border' size='sm'></Spinner>
                          ) : null}
                        </Button>
                      )}

                      {/* {!errors.pan_number && panKyc?.name && !isPanChanged && (
                        <div className='d-flex justify-content-between mx-1'>
                          <div className='font-weight-bold'>
                            <b>Name on PAN : {panKyc?.name}</b>
                          </div>
                          <img src={Verified} width='22px' height='22px' />
                        </div>
                      )} */}
                    </Form.Group>
                    {isPanVerified &&
                    values.is_gstin_available === 'GSTIN_YES' &&
                    gstns.length > 0 ? (
                      <>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-addr'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>GSTIN linked to PAN</Form.Label>
                            </Col>

                            <Col md={8}>
                              {gstns.length > 0 &&
                                gstns.map((item) => (
                                  <RadioCard
                                    label={item.gstin}
                                    id={item.gstin}
                                    name='GSTIN'
                                    onChange={(e) => {
                                      setSelectedGstin(e.target.id);

                                      // if (
                                      //   item.gstin &&
                                      //   item.gstin?.substr(0, 2) !== '27'
                                      // ) {
                                      setIsGstinDisclaimer(true);
                                      setErrorModal({
                                        ...errorModal,
                                        title: 'Disclaimer',
                                        message:
                                          'Please note that for your purchases at the eBullion - Sequel vault, the place of supply would be the state in which the vault is located and you may be able to avail of such applicable input tax credit on your purchases, provided that your GST registration is in the same state. Please check with your consultants before proceeding.',
                                        type: 'warn',
                                      });
                                      // }
                                      setFieldValue('gstin_number', item.gstin);
                                    }}
                                    disabled={
                                      isGstVerified && selectedGstin !== item
                                    }
                                  />
                                ))}
                            </Col>
                          </Row>
                        </Form.Group>
                        {!isGstVerified &&
                          values.is_gstin_available === 'GSTIN_YES' && (
                            <Form.Group>
                              <Button
                                className='w-100 mt-3'
                                variant='primary'
                                type='button'
                                disabled={isGstnLoading}
                                onClick={() =>
                                  getGstinDetails(
                                    values.gstin_number,
                                    setFieldValue,
                                    setFieldError
                                  )
                                }
                              >
                                Continue
                                {isGstnLoading ? (
                                  <Spinner
                                    animation='border'
                                    size='sm'
                                  ></Spinner>
                                ) : null}
                              </Button>
                            </Form.Group>
                          )}
                      </>
                    ) : null}

                    {isPanVerified &&
                    (isGstVerified ||
                      values.is_gstin_available === 'GSTIN_NO') ? (
                      <>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-type'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Company Type*</Form.Label>
                            </Col>

                            <Col md={8}>
                              <Field
                                as='select'
                                className='form-select'
                                ref={companyTypeRef}
                                name='company_type'
                                value={companyDetails.company_type}
                                onChange={(e) => {
                                  if (e.target.value?.length >= 0) {
                                    setCompanyDetails({
                                      ...companyDetails,
                                      company_type: e.target.value,
                                    });
                                    setFieldValue(
                                      'company_type',
                                      e.target.value
                                    );
                                  }
                                }}
                              >
                                <option value={''} selected disabled>
                                  Select Company Type
                                </option>
                                <option value={'HUF'}>
                                  Hindu Undivided Family
                                </option>
                                <option value={'LLP'}>
                                  Limited Liability Partnership
                                </option>
                                <option value={'CO'}>Company</option>
                                <option value={'TRUST'}>Trust</option>
                                <option value={'FIRM'}>Partnership Firm</option>
                              </Field>
                              <div className='error'>
                                {errors.company_type && touched.company_type && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.company_type}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-name'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Company Name*</Form.Label>
                            </Col>

                            <Col md={8}>
                              <Field
                                type='text'
                                className='form-control'
                                ref={companyNameRef}
                                name='company_name'
                                value={companyDetails.company_name}
                                onChange={(e) => {
                                  if (e.target.value?.length >= 0) {
                                    setCompanyDetails({
                                      ...companyDetails,
                                      company_name: e.target.value,
                                    });
                                    setFieldValue(
                                      'company_name',
                                      e.target.value
                                    );
                                  }
                                }}
                                disabled={
                                  values.is_gstin_available === 'GSTIN_YES'
                                }
                              />
                              <div className='error'>
                                {errors.company_name && touched.company_name && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.company_name}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-addr'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Company Address*</Form.Label>
                            </Col>
                            <Col md={8}>
                              <Field
                                type='textarea'
                                className='form-control'
                                ref={addressLineRef}
                                rows={3}
                                name='address_line'
                                value={companyDetails.address_line}
                                onChange={(e) => {
                                  if (e.target.value?.length >= 0) {
                                    setCompanyDetails({
                                      ...companyDetails,
                                      address_line: e.target.value,
                                    });
                                    setFieldValue(
                                      'address_line',
                                      e.target.value
                                    );
                                  }
                                }}
                                disabled={
                                  values.is_gstin_available === 'GSTIN_YES'
                                }
                              />
                              <div className='error'>
                                {errors.address_line && touched.address_line && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.address_line}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-state'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>State*</Form.Label>
                            </Col>
                            <Col md={8}>
                              <Field
                                type='text'
                                className='form-control'
                                ref={stateRef}
                                name='state'
                                value={companyDetails.state}
                                onChange={(e) => {
                                  if (e.target.value?.length >= 0) {
                                    setCompanyDetails({
                                      ...companyDetails,
                                      state: e.target.value,
                                    });
                                    setFieldValue('state', e.target.value);
                                  }
                                }}
                                disabled={
                                  values.is_gstin_available === 'GSTIN_YES'
                                }
                              />
                              <div className='error'>
                                {errors.state && touched.state && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.state}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-city'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>City*</Form.Label>
                            </Col>
                            <Col md={8}>
                              <Field
                                type='text'
                                className='form-control'
                                ref={cityRef}
                                name='city'
                                value={companyDetails.city}
                                onChange={(e) => {
                                  if (e.target.value?.length >= 0) {
                                    setCompanyDetails({
                                      ...companyDetails,
                                      city: e.target.value,
                                    });
                                    setFieldValue('city', e.target.value);
                                  }
                                }}
                                disabled={
                                  values.is_gstin_available === 'GSTIN_YES'
                                }
                              />
                              <div className='error'>
                                {errors.city && touched.city && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.city}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-pincode'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Pin Code*</Form.Label>
                            </Col>
                            <Col md={8}>
                              <Field
                                type='text'
                                className='form-control'
                                ref={pincodeRef}
                                name='pincode'
                                value={companyDetails.pincode}
                                onChange={(e) => {
                                  if (e.target.value?.length <= 6) {
                                    if (/[^0-9]/.test(e.target.value)) return;
                                    setCompanyDetails({
                                      ...companyDetails,
                                      pincode: e.target.value,
                                    });
                                    setFieldValue('pincode', e.target.value);
                                  }
                                }}
                                disabled={
                                  values.is_gstin_available === 'GSTIN_YES'
                                }
                              />
                              <div className='error'>
                                {errors.pincode && touched.pincode && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.pincode}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-mobile'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Mobile Number*</Form.Label>
                            </Col>
                            <Col md={8}>
                              <Field
                                type='text'
                                className='form-control'
                                name='mobile'
                                onChange={(e) => {
                                  if (
                                    e.target.value.length > 10 ||
                                    /[^0-9]/.test(e.target.value)
                                  )
                                    return;
                                  setFieldValue('mobile', e.target.value);
                                  setContact({
                                    ...contact,
                                    mobile: e.target.value,
                                  });
                                }}
                              />
                              <div className='error'>
                                {errors.mobile && touched.mobile && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.mobile}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-email'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Email Address*</Form.Label>
                            </Col>
                            <Col md={8}>
                              <Field
                                type='text'
                                className='form-control'
                                name='email'
                                onChange={(e) => {
                                  setFieldValue('email', e.target.value);
                                  setContact({
                                    ...contact,
                                    email: e.target.value,
                                  });
                                }}
                              />
                              <div className='error'>
                                {errors.email && touched.email && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.email}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.comp-spoc'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Contact Person*</Form.Label>
                            </Col>
                            <Col md={8}>
                              <Field
                                type='text'
                                className='form-control'
                                name='contact_person'
                                onChange={(e) => {
                                  setFieldValue(
                                    'contact_person',
                                    e.target.value
                                  );
                                  setContact({
                                    ...contact,
                                    spoc: e.target.value,
                                  });
                                }}
                              />
                              <div className='error'>
                                {errors.contact_person &&
                                  touched.contact_person && (
                                    <small id='my-helper-text'>
                                      <img src={infoIco} alt='' />
                                      {errors.contact_person}
                                    </small>
                                  )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>

                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.passwd'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Create Password</Form.Label>
                            </Col>
                            <Col md={8}>
                              <InputGroup className='mb-3'>
                                <Field
                                  className='form-control'
                                  name='password'
                                  type={isShowPwd ? 'text' : 'password'}
                                />
                                <div
                                  className='input-group-text'
                                  id='basic-addon1'
                                  style={{
                                    border: '1px solid #ced4da',
                                    borderLeft: '0px',
                                    backgroundColor: 'white',
                                    borderRadius: '0rem 0.25rem 0.25rem 0rem',
                                  }}
                                >
                                  <div onClick={() => setShowPwd(!isShowPwd)}>
                                    <img
                                      className='m-2'
                                      style={{ width: '16px' }}
                                      src={isShowPwd ? hidden : eye}
                                      alt=''
                                    />
                                  </div>
                                </div>
                              </InputGroup>
                              <div className='error'>
                                {errors.password && touched.password && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.password}
                                  </small>
                                )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.cnfpasswd'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Confirm Password</Form.Label>
                            </Col>
                            <Col md={8}>
                              <InputGroup className='mb-3'>
                                <Field
                                  className='form-control'
                                  name='confirm_password'
                                  type={isShowCnfPwd ? 'text' : 'password'}
                                />
                                <div
                                  className='input-group-text'
                                  id='basic-addon1'
                                  style={{
                                    border: '1px solid #ced4da',
                                    borderLeft: '0px',
                                    backgroundColor: 'white',
                                    borderRadius: '0rem 0.25rem 0.25rem 0rem',
                                  }}
                                >
                                  <div
                                    onClick={() => setShowCnfPwd(!isShowCnfPwd)}
                                  >
                                    <img
                                      className='m-2'
                                      style={{ width: '16px' }}
                                      src={isShowCnfPwd ? hidden : eye}
                                      alt=''
                                    />
                                  </div>
                                </div>
                              </InputGroup>
                              <div className='error'>
                                {errors.confirm_password &&
                                  touched.confirm_password && (
                                    <small id='my-helper-text'>
                                      <img src={infoIco} alt='' />
                                      {errors.confirm_password}
                                    </small>
                                  )}
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>

                        <Form.Group
                          className='mb-3 '
                          controlId='entForm.cnfpasswd'
                        >
                          <Row>
                            <Col md={4}>
                              <Form.Label>Referral Code</Form.Label>
                            </Col>
                            <Col md={8}>
                              <InputGroup className='mb-3'>
                                <Field
                                  type='text'
                                  placeholder=''
                                  name='referralCode'
                                  className='form-control'
                                  onChange={(e) => {
                                    setReferralCode(e.target.value);
                                    setInvalidRC('');
                                    if (e.target.value) {
                                      isValidReferral(
                                        e.target.value,
                                        setFieldError
                                      );
                                    }
                                  }}
                                  maxLength={12}
                                  value={referralCode}
                                />
                              </InputGroup>
                              <div className='error'>
                                {errors.referralCode && touched.referralCode && (
                                  <small id='my-helper-text'>
                                    <img src={infoIco} alt='' />
                                    {errors.referralCode}
                                  </small>
                                )}
                              </div>
                              <div className='d-flex justify-content-between mx-1 my-2'>
                                <div className='font-weight-bold'>
                                  <b>{busPartName}</b>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>
                        <Form.Group>
                          <Row>
                            <Col md={4}></Col>
                            <Col md={8}>
                              <label className='form-label'>
                                <Field
                                  type='checkbox'
                                  placeholder=''
                                  name='agree'
                                  className='mx-1'
                                  checked={values.agree === true}
                                  onChange={(e) =>
                                    setFieldValue(
                                      'agree',
                                      e.target.checked ? true : false
                                    )
                                  }
                                />
                                I agree to the{' '}
                                <a
                                  href='https://ebullion.in/terms-and-conditions/terms.html'
                                  target='_blank'
                                >
                                  terms and conditions
                                </a>
                              </label>

                              <div className='form-group mb-4'>
                                <div className='error'>
                                  {errors.agree && touched.agree && (
                                    <small id='my-helper-text'>
                                      <img src={infoIco} alt='' />
                                      {errors.agree}
                                    </small>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </Form.Group>

                        <Form.Group>
                          <Button
                            className='w-100 mt-3'
                            variant='primary'
                            type='submit'
                            disabled={loading}
                            // onClick={() => onProceed()}
                          >
                            Create Account
                            {loading ? (
                              <Spinner animation='border' size='sm'></Spinner>
                            ) : null}
                          </Button>
                        </Form.Group>
                      </>
                    ) : null}
                  </FormikForm>
                )}
              </Formik>
            </div>
            <div className='text-center sign-in-text'>
              <a onClick={(e) => history.push('/signin')}>
                Already registered? <span>Sign in</span>{' '}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterpriseSignup;
